import React, { useState, useEffect } from 'react';
import '../css/LiquidIntro.css';

const LiquidIntro = () => {
    const [isRemoved, setIsRemoved] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setIsRemoved(true), 3000);
        return () => clearTimeout(timer);
    }, []);

    if (isRemoved) return null;

    return (
        <div className="intro-mask">
            {/* 垂直落下的圓點 */}
            <div className="dropping-dot"></div>

            {/* 公司名稱揭示 */}
            <div className="intro-content">
                <div className="big-title-ch">湯武生技</div>
                <div className="title-en">TANG WU BIOTECH</div>
            </div>
        </div>
    );
};

export default LiquidIntro;